<template>
  <section class="section">
    <div class="container">
      <div class="tabs is-right" id="menureportes">
        <ul v-if="showMenu(['admin', 'auxiliar', 'contador', 'gerente'])">
          <router-link tag="li" :to="{ name: 'reports.iva' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>IVA</span>
            </a>
          </router-link>
        </ul>
        <ul
          v-if="
            showMenu(['vendedor', 'admin', 'auxiliar', 'contador', 'gerente'])
          "
        >
          <router-link tag="li" :to="{ name: 'reports.inventario' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Inventario</span>
            </a>
          </router-link>
        </ul>
        <ul v-if="showMenu(['admin', 'auxiliar', 'contador', 'gerente'])">
          <router-link tag="li" :to="{ name: 'reports.auxiliar' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Movimiento</span>
            </a>
          </router-link>
        </ul>
        <ul v-if="showMenu(['admin', 'auxiliar', 'contador', 'gerente'])">
          <router-link tag="li" :to="{ name: 'reports.accountbalancebeta' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Balance</span>
            </a>
          </router-link>
        </ul>
        <ul
          v-if="
            showMenu(['admin', 'auxiliar', 'contador', 'gerente', 'vendedor'])
          "
        >
          <router-link tag="li" :to="{ name: 'reports.fraelectlist' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">assignment_turned_in</span>
              </span>
              <span>Fra Electronica</span>
            </a>
          </router-link>
        </ul>
      </div>
      <div v-if="isinicial">
        <div class="notification">
          <h1 class="title is-4">Reportes</h1>
          <h2 class="subtitle is-6">
            yungol la nueva forma de llevar la contabilidad.
          </h2>
          <p>
            En este módulo podrá encontrar los diferentes informes, para
            gestionar su empresa.
          </p>
        </div>
      </div>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tabs li.router-link-exact-active a {
  border-bottom-color: #3273dc;
  border-bottom-width: 2px;
  color: #3273dc;
}
</style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      routeaqui: null,
    };
  },
  computed: {
    ...mapState(["tokenUser"]),
    isinicial() {
      return this.$route.name === "reports";
    },
  },
  methods: {
    showMenu(scopes) {
      const _this = this;
      let returned = false;
      for (let index in scopes) {
        const scope = scopes[index];
        if (_this.tokenUser && _this.tokenUser[scope]) {
          returned = true;
        }
      }
      return returned;
    },
  },
  created() {
    this.routeaqui = this.$route.name;
  },
};
</script>

<style lang='scss'>
@media print {
  #menureportes {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/reports/Reports.vue